import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class ProductApi extends ApiClient {
  public constructor(options: ApiClientOptions = {}) {
    super(getServiceUrl('core'), options);
    this.defaultTargetMarketId = options.defaultTargetMarketId || 250;
  }

  // =============================================================================
  //                            Product V3 APIs
  // =============================================================================

  public ProductValidateVersion(productVersion: any) {
    const query = `/core/v3/products/versions/validate`;

    const payload = {
      data: productVersion,
    };
    return this.post(query, payload);
  }

  public ProductAcceptV3(
    productId: number,
    brandId: number,
    segmentId?: number,
  ) {
    const query = `/core/v3/products/${productId}/accept`;
    const payload: any = {
      brand: {
        id: brandId,
      },
    };
    if (segmentId) {
      payload.productSegment = { id: segmentId };
    }
    return this.post(query, payload);
  }

  public ProductVersionAutoEnrichAll() {
    const query = '/core/v3/issharedwith/autoenrich';
    return this.post(query);
  }

  public SyncRetailer(organizationId: number, seedShares: boolean) {
    const route = '/core/v3/sync_retailer';
    return this.post(route, {
      organization_id: organizationId,
      seed_missing_shares: seedShares,
    });
  }
}
